export enum SurgeryManagementStatus {
  CANCELLED = "cancelled",
  ONGOING = "ongoing",
  CONFIRMED = "confirmed",
  VALIDATED = "validated",
  CLOSED = "closed",
  SUSPENDED = "suspended",
  MONITORONGOING = "monitorongoing",
}
